import styled from "styled-components";

export default function Sidebar() {
    return (
        <Main>
            <div>
                <h3
                className={'active'}
                >
                    Profile
                </h3>
            </div>
        </Main>
    )
}

const Main = styled.aside`
> div {
    margin: 20px auto;
    width: fit-content;
    h3 {
        font-size: 16px;
        margin-bottom: 10px;
        font-weight: 400;
        color: ${props => props.theme.gray};
        cursor: pointer;
        transition: color .2s ease;
        &.active {
            color: #000;
        }
    }
}
`